import {
    useEffect,
} from 'react';

import {
    SimpleGrid,
    Table,
} from '@mantine/core';

import {useReportRuns} from '../hooks/useReportRuns';
import {PaginationControls} from '../../../components/PaginationControls';

import {
    SimpleTableBatchAction,
    TableBody,
    TableBodyColumn,
    TableHeaderColumn,
    TableHeaderRow,
} from '@flexinet/ui-components';
import {IReportRunTableColumn} from '../types';
import {getColumns} from '../tables/columns';

export const RecordsTable = () => {

    const {
        visibleItems,
        loading,
        fetchRecords,
        handleFilterByKeyword,
        currentPage,
        hasNext,
        hasPrevious,
        goToNextPage,
        goToPreviousPage,
    } = useReportRuns();

    useEffect(() => {
        fetchRecords();
    }, []);

    const tableColumns: IReportRunTableColumn[] = getColumns();

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <SimpleTableBatchAction
                limit={10}
                handleItemsPerPageChange={() => {}}
                handleFilterByKeyword={handleFilterByKeyword}
            />
            <Table verticalSpacing='sm' striped highlightOnHover>
                <TableHeaderRow
                    columns={tableColumns as unknown as TableHeaderColumn[]}
                />
                <TableBody
                    items={visibleItems}
                    loading={loading}
                    selection={{}}
                    columns={tableColumns as unknown as TableBodyColumn[]}
                />
            </Table>
            <PaginationControls
                currentPage={currentPage}
                hasNext={hasNext}
                hasPrevious={hasPrevious}
                onNext={goToNextPage}
                onPrevious={goToPreviousPage}
                loading={loading}
            />
        </SimpleGrid>
    );
};
